export default {
    // 公共
    hello:"Hello~",
    welcome: "Welcome to the Plus18 Games Customer Service Center",
    connecting: "Your dedicated customer service representative is connecting...",
    connected: "Your dedicated customer service representative is connected",
    waitting: "Please wait a moment",
    click_to_chat: "Please click the button at the bottom right to start chatting",
    email:"Customer Service Email",

}